import { useNotification } from '../../shared/notification/useNotification';
import { ClientInformationDto } from '../models/FitConnect/FitConnect';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../beh-api';
import { ErrorType } from '../../shared/utils/Error/ErrorCode';

export function useFitConnectClientInformationUpdate() {
  const { notifyUserFromRequest, notifyUser } = useNotification();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (clientInformationDto: ClientInformationDto) =>
      notifyUserFromRequest(
        () =>
          behClient.put(
            BehApiRoutes.fitConnectSenderInformation(),
            clientInformationDto
          ),
        {
          successMessage: t('api.success.createFitConnectSenderCreds'),
          errorMessage: t('api.error.createFitConnectSenderCreds'),
          errorIdHandler: {
            'behoerdenclient/problems/clientInvalid': () => {
              notifyUser({
                intent: 'error',
                title: t('api.error.createFitConnectSenderCreds.invalidCreds')
              });
            },
            [ErrorType.BEHOERDENCLIENT_PROBLEMS_ILLEGAL_CREDENTIAL_NOT_A_SENDER]:
              () => {
                notifyUser({
                  intent: 'error',
                  title: t('api.error.createFitConnectSenderCreds.notASender')
                });
              }
          }
        }
      )
  });
}
